/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateSestMaintenanceScheduleRequest = {
  /**
   * puid
   */
  puid: string;
  /**
   * 유저설정 기준 주행거리
   */
  customStdDistance?: number;
  /**
   * 유저설정 기준 일 수
   */
  customStdDays?: number;
  /**
   * 관리주기 타입: 복합: 0, 거리::1 , 일자:2 (COMBINED, DISTANCE, DAY)
   */
  maintenanceType?: CreateSestMaintenanceScheduleRequest.maintenanceType;
};
export namespace CreateSestMaintenanceScheduleRequest {
  /**
   * 관리주기 타입: 복합: 0, 거리::1 , 일자:2 (COMBINED, DISTANCE, DAY)
   */
  export enum maintenanceType {
    COMBINED = 'COMBINED',
    DISTANCE = 'DISTANCE',
    DAY = 'DAY',
  }
}

